import * as Types from '../mutation-types'
import { API_STATES } from '@/helpers'
import { pick } from 'lodash'

const employeeCostMutations = {
  [Types.LOAD_EMPLOYEE_COST_DATA_BEGIN](state) {
    state.costDataGetSate = API_STATES.REQUEST_PENDING
  },
  [Types.LOAD_EMPLOYEE_COST_DATA_SUCCESS](state, data) {
    state.costDataGetError = null
    state.costData = data
    state.costDataGetSate = API_STATES.REQUEST_SUCCESS
  },
  [Types.LOAD_EMPLOYEE_COST_DATA_ERROR](state, err) {
    state.costDataGetSate = API_STATES.REQUEST_ERROR
    state.costDataGetError = err
  },
  [Types.SET_EMPLOYEE_BENEFIT_EDIT_MODE](state, value){
    state.userBenefitEditMode = value
  },
  [Types.SET_EMPLOYEE_COST_EDIT_MODE](state, value){
    state.userCostEditMode = value
  },
  [Types.UPDATE_EMPLOYEE_COSTS_BEGIN](state) {
    state.userCostsUpdateState = API_STATES.REQUEST_PENDING
  },
  [Types.UPDATE_EMPLOYEE_COSTS_SUCCESS](state, updatedData) {
    state.userCostsUpdateError = null
    
    const mappedUserPositions = {}
    
    state.costData.userPositions.forEach(up => {
      mappedUserPositions[up.id] = up
    })
    
    const updatedUserPositions = updatedData.slice(1)
    
    state.costData = { 
      ...state.costData, 
      ...pick(updatedData[0].data, ['cost', 'cost_type']),
      userPositions : updatedUserPositions.length ? state.costData.userPositions.map(up => {
        let updatedUserPosition = null
        
        if((updatedUserPosition = updatedUserPositions.find(({ data }) => data.id === up.id))){
          return {
            ...up,
            hourlyRate : parseFloat(updatedUserPosition.data.hourlyRate)
          }
        }

        return up
      }) : state.costData.userPositions 
    }
    

    state.userCostEditMode = false
    state.userCostsUpdateState = API_STATES.REQUEST_SUCCESS
  },
  [Types.UPDATE_EMPLOYEE_COSTS_ERROR](state, err) {
    state.userCostsUpdateState = API_STATES.REQUEST_ERROR
    state.userCostsUpdateError = err
  },
  [Types.UPDATE_USER_BENEFIT_COST_BEGIN](state) {
    state.userBenefitCostUpdateState = API_STATES.REQUEST_PENDING
  },
  [Types.UPDATE_USER_BENEFIT_COST_SUCCESS](state, userBenefits) {
    state.userBenefitCostUpdateError = null
    
    const mappedUserBenefits = {}
    
    state.costData.userBenefits.forEach(ub => {
      mappedUserBenefits[ub.id] = ub
    })
    
    state.costData = { 
      ...state.costData, userBenefits : userBenefits.map(({ data }) => ({
        ...mappedUserBenefits[data.id],
        cost : parseFloat(data.cost)
      })) 
    }

    state.userBenefitEditMode = false
    state.userBenefitCostUpdateState = API_STATES.REQUEST_SUCCESS
  },
  [Types.UPDATE_USER_BENEFIT_COST_ERROR](state, err) {
    state.userBenefitCostUpdateState = API_STATES.REQUEST_ERROR
    state.userBenefitCostUpdateError = err
  },
}

export default employeeCostMutations
